import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  inputsWrapper: {
    marginBottom: 16,
    display: "flex",
    gap: 16,
    "& .ant-form-item": {
      marginBottom: 0,
    },
  },
  input: {
    flexBasis: "100%",
    "& input": {
      borderRadius: "8px !important",
    },
    "& .ant-input-number-handler-wrap": {
      display: "none",
    },
  },
  actionTitle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  beneficiaryWrapper: {
    position: "relative",
    marginTop: 16,
    borderRadius: 8,
    padding: 16,
    border: "1px solid rgb(220, 220, 220)",
  },
  beneficiaryRemove: {
    position: "absolute",
    right: 4,
    top: 4,
  },
  lotTabs: {
    "& .ant-tabs-nav": {
      position: "relative !important",
    },
  },
});
